import type { NavigationEntry } from "@positive/ui";
import "@ui5/webcomponents-icons/dist/bar-chart.js";
import "@ui5/webcomponents-icons/dist/credit-card.js";
import "@ui5/webcomponents-icons/dist/inventory.js";
import "@ui5/webcomponents-icons/dist/lateness.js";
import "@ui5/webcomponents-icons/dist/lead.js";
import "@ui5/webcomponents-icons/dist/machine.js";
import "@ui5/webcomponents-icons/dist/money-bills.js";
import "@ui5/webcomponents-icons/dist/monitor-payments.js";
import "@ui5/webcomponents-icons/dist/settings.js";
import "@ui5/webcomponents-icons/dist/shield.js";
import "@ui5/webcomponents-icons/dist/warning2.js";

import { posPermissions } from "./permissions";

/** POS back-office entries of the navigation registry (group `pos`, ADR-0022). */
export const posNavigation: readonly NavigationEntry[] = [
  {
    key: "pos.issues",
    labelKey: "nav.posIssues",
    icon: "warning2",
    path: "/pos/sync-issues",
    permission: posPermissions.syncIssueView,
  },
  {
    key: "pos.shifts",
    labelKey: "nav.posShifts",
    icon: "monitor-payments",
    path: "/pos/shifts",
    permission: posPermissions.shiftView,
  },
  {
    key: "pos.sales",
    subGroup: "reports",
    labelKey: "nav.posSales",
    icon: "bar-chart",
    path: "/pos/sales",
    permission: posPermissions.salesAnalysisView,
  },
  {
    key: "pos.kitchenTimes",
    subGroup: "reports",
    labelKey: "nav.posKitchenTimes",
    icon: "lateness",
    path: "/pos/kitchen-times",
    permission: posPermissions.salesAnalysisView,
  },
  {
    key: "pos.cards",
    subGroup: "reports",
    labelKey: "nav.posCards",
    icon: "credit-card",
    path: "/pos/card-reconciliation",
    permission: posPermissions.salesView,
  },
  {
    key: "pos.cashAudit",
    labelKey: "nav.posCashAudit",
    icon: "money-bills",
    path: "/pos/cash-audit",
    permission: posPermissions.cashAuditView,
  },
  {
    key: "pos.drawer",
    labelKey: "nav.posDrawer",
    icon: "lead",
    path: "/pos/drawer",
    permission: posPermissions.drawerView,
  },
  {
    key: "pos.branchOperations",
    labelKey: "nav.posBranchOperations",
    icon: "inventory",
    path: "/pos/branch-operations",
    permission: posPermissions.branchOperationView,
  },
  {
    key: "pos.overrides",
    subGroup: "reports",
    labelKey: "nav.posOverrides",
    icon: "shield",
    path: "/pos/supervisor-overrides",
    permission: posPermissions.overrideView,
  },
  {
    key: "pos.terminals",
    subGroup: "setup",
    labelKey: "nav.posTerminals",
    icon: "machine",
    path: "/pos/terminals",
    permission: posPermissions.terminalView,
  },
  {
    key: "pos.profiles",
    subGroup: "setup",
    labelKey: "nav.posProfiles",
    icon: "settings",
    path: "/pos/profiles",
    permission: posPermissions.profileView,
  },
];
